export default function EFPhone(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none" {...props}>
            <path
                d="M51.3707 61.1997C51.1649 61.4494 50.9065 61.6506 50.6139 61.789C50.3214 61.9273 50.0018 61.9993 49.6782 61.9999H27.1704"
                stroke="white"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M51.1499 16.5977C51.3632 16.8021 51.5327 17.0478 51.6481 17.3197C51.7635 17.5917 51.8225 17.8843 51.8213 18.1797V59.8197C51.8331 60.3176 51.6741 60.8045 51.3706 61.1994"
                stroke="white"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.5059 16.7727C25.7113 16.5315 25.9664 16.3377 26.2538 16.2043C26.5411 16.0709 26.8539 16.0012 27.1707 16H49.651C50.2085 16.002 50.7444 16.2157 51.1503 16.5979"
                stroke="white"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25 59.8202V18.1802C25.002 17.667 25.1807 17.1701 25.5059 16.7729"
                stroke="white"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.5243 61.2455C25.1843 60.8485 24.9982 60.3426 25 59.8198"
                stroke="white"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M27.1704 61.9907C26.8587 61.9908 26.5506 61.9244 26.2667 61.796C25.9827 61.6675 25.7295 61.4798 25.5239 61.2456"
                stroke="white"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M49.1817 21.2061H27.6489V54.3101H49.1817V21.2061Z" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M38.4107 59.9216C39.4674 59.9216 40.324 59.0651 40.324 58.0084C40.324 56.9518 39.4674 56.0952 38.4107 56.0952C37.3541 56.0952 36.4976 56.9518 36.4976 58.0084C36.4976 59.0651 37.3541 59.9216 38.4107 59.9216Z"
                stroke="white"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M34.8696 17.9229H35.8171" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M36.9023 17.9229H40.324" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="38" cy="38" r="37" stroke="white" strokeWidth="2" />
        </svg>
    );
}
